export class CreateAccountTestProps {
    constructor(public json: string = '{}') {}
}
